import { useSelector } from 'react-redux';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { Table } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getCustomRenderers, getTableSchema } from '../utils';

const SOSTable = ({
  currency,
  sosOptions = [],
  referenceId,
  requestedQuantity,
  isAvailabilityToggled = false
}) => {
  const [t] = useTranslation();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const isStoreAvailabilityEnabled = useSelector(
    s => s.dealer?.isStoreAvailabilityEnabled
  );
  const isQuantityMergeEnabled = useSelector(
    s => s?.common?.isQuantityMergeEnabled
  );

  const hoseAvailabilityLabel = useSelector(
    s => s.common?.hoseAvailabilityLabel
  );
  const isDeliveryEnabled = useSelector(
    state => state.common.isDeliveryEnabled
  );
  const isPickUpEnabled = useSelector(state => state.dealer.isPickupEnabled);
  const sosTableSchema = getTableSchema(
    t,
    currency,
    isLG,
    isQuantityMergeEnabled,
    isDeliveryEnabled,
    isPickUpEnabled
  );
  const data = sosOptions.map((opt, idx) => ({
    ...opt,
    id: idx,
    item: `${opt.sosPartNumber}: ${opt.sosPartName}`,
    referenceId,
    requestedQuantity,
    displayAvailabityAndSourcingDetails: isAvailabilityToggled
  }));

  return (
    <div className="px-2" key={sosOptions[0].partNumber}>
      <Table
        keyGenerator={item =>
          `${item.sosPartNumber}${item.sosPartName}${item.sosCode}`
        }
        schema={sosTableSchema}
        data={data}
        customRenderers={getCustomRenderers(
          currency,
          isStoreAvailabilityEnabled,
          hoseAvailabilityLabel,
          isAvailabilityToggled
        )}
      />
    </div>
  );
};

SOSTable.propTypes = {
  sosOptions: PropTypes.arrayOf(
    PropTypes.shape({
      sosPartNumber: PropTypes.string,
      sosPartName: PropTypes.string,
      unitPrice: PropTypes.string,
      sos: PropTypes.string,
      availability: PropTypes.arrayOf(
        PropTypes.shape({
          availabilityMessage: PropTypes.string,
          quantityAvailable: PropTypes.string
        })
      ),
      errors: PropTypes.shape({
        errorMessage: PropTypes.string,
        errorCode: PropTypes.string
      }),
      coreCharges: PropTypes.string,
      sosCode: PropTypes.string
    })
  ),
  currency: PropTypes.string,
  referenceId: PropTypes.string,
  requestedQuantity: PropTypes.string,
  isAvailabilityToggled: PropTypes.bool
};

export default SOSTable;
